// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const tipoClientesFullfilledReducer = makeSetReducer(['tipo_clientes/fullfilled']);
